import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import type { ProductOffer } from 'v2/interfaces/product';

import { useStyles } from './styles';

function Header() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation<{ offer: ProductOffer }>();
  const offer = location.state?.offer;

  function handleBack() {
    history.goBack();
  }

  return (
    <header className={classes.container}>
      <Typography variant='h4' component='h1'>
        {offer.name}
      </Typography>
      <Button id='back-button' onClick={handleBack} variant='outlined'>
        Voltar
      </Button>
    </header>
  );
}

export { Header };
